export default {
  namespaced: true,
  state: {
    isMobile: false,
    isPc:true,
  },
  mutations: {
    setMobile: (state, payload) => {
      state.isMobile = payload;
    },
    setPc: (state, payload) => {
      state.isPc = payload;
    }
  },
};
